import ISymbolSpineAnimConfigMethods from "../managers/contracts/configurations/spine_anim/ISymbolSpineAnimConfigMethods";
import ISpineAnimStateConfig from "../managers/contracts/configurations/spine_anim/ISpineAnimStateConfig";
import IChainingSpineAnimConfig from "../managers/contracts/configurations/spine_anim/IChainingSpineAnimConfig";
import {ConfigurationTypes} from "../const/ConfigurationTypes";
import ISceneSpineAnimConfig from '../managers/contracts/configurations/ISceneSpineAnimConfig';
import ISpineAnimSkinConfig from '../managers/contracts/configurations/spine_anim/ISpineAnimSkinConfig';
import IBaseSpineAnimConfig from '../managers/contracts/configurations/spine_anim/IBaseSpineAnimConfig';
import IConfiguration from '../managers/contracts/configurations/IConfiguration';
export default abstract class AbstractSymbolSpineAnimationsConfig implements ISymbolSpineAnimConfigMethods, IBaseSpineAnimConfig, IConfiguration {
    type: ConfigurationTypes = ConfigurationTypes.SYMBOL_SPINE_ANIMATIONS;
    name: string;
    states: ISpineAnimStateConfig[];
    visible: boolean;
    hasSkins: boolean;
    skins: ISpineAnimSkinConfig[];
    getChainingAnimConfig(chainingAnim: string, skin: string): IChainingSpineAnimConfig {
        return this.getSkinConfig(skin)?.chainingStates?.find(data => data.name === chainingAnim) || null
    }
    getStateConfig(state: string) {
        let result = null;
        for (let i = 0; i < this.states.length; i++) {
            const stateConfig = this.states[i];
            if (stateConfig.name === state) {
                result = stateConfig; break;
            }
        }

        if (result === null) {
            console.warn(
                `[SPINE ANIMATION] -> state <${state}> Has not a configuration in SymbolSpineAnimationsConfig`,
                this.skins
            );
        }

        return result
    }
    getSkinConfig(skinName: string) {
        let result = null;
        for (let i = 0; i < this.skins.length; i++) {
            const skin = this.skins[i];
            if (skin.name === skinName) {
                result = skin; break;
            }
        }

        if (result === null) {
            console.warn(
                `[SPINE ANIMATION] -> skin <${skinName}> Has not a configuration in SymbolSpineAnimationsConfig`,
                this.skins
            );
        }

        return result
    }

}
